import { createAsyncTypes } from 'utils/ActionCreator'

export const MAILBOX_PROTECTION_REQUEST_ASYNC = createAsyncTypes(
  'MAILBOX_PROTECTION_SETTINGS_REQUEST',
  'Settings/MailboxProtection'
)
export const UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC = createAsyncTypes(
  'UPDATE_MAILBOX_PROTECTION_SETTINGS_REQUEST',
  'Settings/MailboxProtection'
)

export const CHANGE_BANNERS_LANGUAGE = 'Settings/MailboxProtection/CHANGE_BANNERS_LANGUAGE'
export const CHANGE_FIELD = 'Settings/MailboxProtection/CHANGE_FIELD'
